import { ConfigType } from '@/types/configType';
import React, { createContext, useContext, useState } from 'react';

interface SpecUrlsContextType {
  specUrls: ConfigType[];
  setSpecUrls: (urls: ConfigType[]) => void;
  getSpecUrl: (urls: ConfigType[], activeName: string) => ConfigType | undefined;
}

const SpecUrlsContext = createContext<SpecUrlsContextType | undefined>(undefined);

export const useSpecUrls = (): SpecUrlsContextType => {
  const context = useContext(SpecUrlsContext);
  if (!context) {
    throw new Error('useSpecUrls must be used within a SpecUrlsProvider');
  }
  return context;
};

export const SpecUrlsProvider: React.FC = ({ children }) => {
  const [specUrls, setSpecUrls] = useState<ConfigType[]>([{ url: '', name: '', group: '' }]);

  const getSpecUrl = (urls: ConfigType[], activeName: string): ConfigType | undefined => {
    if (urls.length == 0 || !activeName) return undefined;

    const currentUrl = urls.filter(({ name }) => name == activeName);
    if (currentUrl.length == 0) return undefined;

    return currentUrl[0];
  };

  return <SpecUrlsContext.Provider value={{ specUrls, setSpecUrls, getSpecUrl }}>{children}</SpecUrlsContext.Provider>;
};
